import { render, staticRenderFns } from "./StorageSelection.vue?vue&type=template&id=f5204032&scoped=true&lang=html&"
import script from "./StorageSelection.vue?vue&type=script&lang=ts&"
export * from "./StorageSelection.vue?vue&type=script&lang=ts&"
import style0 from "./StorageSelection.vue?vue&type=style&index=0&id=f5204032&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5204032",
  null
  
)

export default component.exports